import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AmsUserListItem extends AmsListItemBase {
    id: string = '';
    amsID: string = '';
    userID: string = '';
    passWord: string = '';
    name: string = '';
    email: string = '';
    amsSubGroup: string = '';
    shareData: string = '';
    subUsers: string = '';
    hasData: string = '';
    acctStatus: string = '';
    
    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, filterable: false }),
        XCol.Create({ col: 1, text: 'SCAC', width: 60, dataIndex: 'amsID'}),
        XCol.Create({ col: 2, text: 'User ID', width: 100, dataIndex: 'userID', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Password', width: 80, dataIndex: 'passWord'}),
        XCol.Create({ col: 4, text: 'Name', width: 150, dataIndex: 'name'}),
        XCol.Create({ col: 5, text: 'Email', width: 200, dataIndex: 'email'}),
        XCol.Create({ col: 6, text: 'Share Data', width: 70, dataIndex: 'shareData', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 7, text: 'Sub Users', width: 60, dataIndex: 'subUsers', filterType: 'number', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 8, text: 'Has Data', width: 60, dataIndex: 'hasData', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 9, text: 'Account Status', width: 100, dataIndex: 'acctStatus', align: XCol.XAlignType.Center }),

        // XCol.Create({ col: 1, text: 'ID', width: 80, dataIndex: 'id', align: XCol.XAlignType.Right, hiddenInColumnSetup: true }),
        // XCol.Create({ col: 8, text: 'Agent ID', width: 100, dataIndex: 'agentId'}),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AmsUserListItem.prototype.userID, orderByAscending: true };

    public static formatData(data: AmsUserListItem[]) {
        return data.map((d: AmsUserListItem) => ({
          ...d,
        }));
    }

}
